import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {FedexFile} from './model';

export interface FedexFileState extends EntityState<FedexFile> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'FedexFile' })
export class Store extends EntityStore<FedexFileState> {

  constructor() {
    super();
  }

}
